import {
	CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK,
	SYS_BORDER_RADIUS_MD,
	SYS_PAGE_MARGIN,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-alpha-common';
import { Collapsible } from '@radix-ui/react-collapsible';
import styled from 'styled-components';
import { slideDown, slideUp } from '~/components/selection-card-new/styles/selection-card-styles';

export const GlobalDisclaimerBarStyles = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	min-height: 56px;
	background: ${(props) => props.theme.sys.color.canvas['200']};
	padding: ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN} 0;

	.inner-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: ${(props) => props.theme.sys.gradient.elevation.level2.fill};
		border: 1px solid ${(props) => props.theme.sys.color.elevation.level2.stroke};
		padding: ${SYS_SPACE_FIXED_200};
		border-radius: ${SYS_BORDER_RADIUS_MD};
	}

	.close-button {
		align-self: flex-start;
	}
`;

export const GlobalDisclaimerLayerStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;

	.okay-button {
		width: 180px;
	}
`;

export const CategoryDisclaimerStyles = styled(Collapsible)`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 16px;
	gap: 6px;
	background: ${(props) => props.theme.sys.gradient.elevation.level2.fill};
	border: 1px solid ${(props) => props.theme.sys.color.elevation.level2.stroke};
	border-radius: ${SYS_BORDER_RADIUS_MD};

	.info {
		display: flex;
		align-items: center;
		gap: 8px;
		color: ${CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK};
	}

	.headline {
		color: ${CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK};
	}

	.icon,
	button {
		min-width: fit-content;
	}

	.link {
		display: flex;
		flex-wrap: wrap;
		gap: 0 8px;
	}

	.disclaimer-content-wrapper {
		overflow: hidden;
	}
	.disclaimer-content-wrapper[data-state='open'] {
		animation: ${slideDown} 400ms ease;
	}

	.disclaimer-content-wrapper[data-state='closed'] {
		animation: ${slideUp} 400ms ease;
	}
`;
